import React from 'react';

export const MapDistanceInfo = ({ distance, routeDistance, routeDuration }) => {
  // Prefer OSRM-computed distance; fall back to backend distance prop
  const displayDistance = routeDistance > 0 ? routeDistance : (Number(distance) || 0);
  const avgSpeed = routeDistance > 0 && routeDuration > 0
    ? Math.round((routeDistance / (routeDuration / 3600)) * 10) / 10
    : null;

  return (
    <div className="map-info-box map-info-box--compact">
      <div className="map-info-box__metric">
        <span className="map-info-box__label">{__('routes.distance_sum')}</span>
        <span className="map-info-box__value">{displayDistance} km</span>
      </div>
      {avgSpeed !== null && (
        <div className="map-info-box__metric">
          <span className="map-info-box__label">{__('routes.avg_speed')}</span>
          <span className="map-info-box__value">{avgSpeed} km/h</span>
        </div>
      )}
    </div>
  );
};
